/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_SearchInputs */

const en_us2_shell_search = /** @type {(inputs: Shell_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const pt_br2_shell_search = /** @type {(inputs: Shell_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const es_419_shell_search = /** @type {(inputs: Shell_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar`)
};

const pt_pt2_shell_search = /** @type {(inputs: Shell_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar`)
};

const fr_fr2_shell_search = /** @type {(inputs: Shell_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher`)
};

const de_de2_shell_search = /** @type {(inputs: Shell_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen`)
};

const it_it2_shell_search = /** @type {(inputs: Shell_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Shell_SearchInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_search = /** @type {((inputs?: Shell_SearchInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_SearchInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_search(inputs)
	if (locale === "es-419") return es_419_shell_search(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_search(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_search(inputs)
	if (locale === "de-DE") return de_de2_shell_search(inputs)
	if (locale === "it-IT") return it_it2_shell_search(inputs)
	return en_us2_shell_search(inputs)
});
export { shell_search as "shell.search" }